export const disqus = () => {
	var d = document,
		s = d.createElement("script");
	s.src = "https://huqas-1.disqus.com/embed.js";
	s.setAttribute("data-timestamp", +new Date());
	(d.head || d.body).appendChild(s);
};
